import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Routes,
} from "react-router-dom";

import Login from "./Login";
import PrivateRoute from "../util/PrivateRoute";
import HomePage from "../pages/HomePage";
import SignUp from "./SignUp";
import ForgotPassword from "./ForgotPassword";
import Header from "../layout/Header";
import Title from "../layout/Title";
import Decision from "../pages/Decision";
import AllFlyers from "../pages/AllFlyers";
import FlyerOptions from "../pages/FlyerOptions";
import AdminPage from "../pages/AdminPage";
import NotificationBanner from "./NotificationBanner";

function App() {
  const BASE_PATH = "/flyer-generator";
  return (
    <div className="App">
      <Router basename={BASE_PATH}>
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute path="/">
                <HomePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/decision"
            element={
              <PrivateRoute path="/">
                <Decision />
              </PrivateRoute>
            }
          />
          <Route
            path="/select-flyer"
            element={
              <PrivateRoute path="/">
                <Header />
                <NotificationBanner />
                <Title title="Select Your Flyer" settingsButton={false} />
                <AllFlyers />
              </PrivateRoute>
            }
          />
          <Route
            path="/flyer-options"
            element={
              <PrivateRoute path="/">
                <Header />
                <Title title="Choose your options" settingsButton={true} />
                <FlyerOptions />
              </PrivateRoute>
            }
          />
          <Route exact path="/signup" element={<SignUp />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/admin" element={<AdminPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
